import { createTheme, colors } from "@mui/material";
import shadows from "./shadows";
import typography from "./typography";
import BreakPoints from "./breakPoints";

const basePalette = {
  background: {
    dark: "#2F4858",
    gray: "#EBEBEB",
    gradient:
      "linear-gradient(65.54deg, #FE7563 12.26%, #FE7663 20.52%, #FE9368 83.36%)",
    green: "#98FFAF",
    red: "#FF8282",
  },
  borders: { green: "#81DF96", red: "#EB6969", gray: "#CFCFCF" },
  primary: { main: "#2F4858", light: colors.common.white },
  secondary: {
    main: "#2F4858",
    background: "#2F4858",
    light: colors.common.white,
    contrastText: colors.common.white,
  },
};

const lightText = {
  main: "#FFF",
  primary: "#2A2F3A",
  secondary: "#5A6472",
  black: "black",
  darkGray: "#4D4D4D",
  bttnGray: "#575757",
  lightBlue: "#2C67DA",
  gray: "#666666",
  lightGray: "#BDBFD8",
  green: "#3C7129",
  red: "#E02B2F",
  white: "#FFFFFF",
  yellow: "#FC902D",
  orange: "#C1854D",
  textPrimary: "#FFF",
};

const darkText = {
  ...lightText,
  primary: "#E6E9ED",
  secondary: "#AEB6C2",
};

export const getTheme = (mode = "light") =>
  createTheme({
    breakpoints: { values: BreakPoints },
    palette: {
      mode,
      ...basePalette,
      background: {
        ...basePalette.background,
        default: mode === "dark" ? "#14181E" : colors.common.white,
        paper: mode === "dark" ? "#1E242C" : colors.common.white,
      },
      divider: mode === "dark" ? "rgba(255,255,255,0.09)" : "#E9ECF0",
      text: mode === "dark" ? darkText : lightText,
    },
    shadows,
    typography,
  });

const theme = getTheme("light");
export default theme;
